export const taskSizes = new Map()
taskSizes.set('none', { next: 'small' })
taskSizes.set('small', { next: 'medium' })
taskSizes.set('medium', { next: 'large' })
taskSizes.set('large', { next: 'none' })
